/* Hero slideshow: fade tussen slides, streepjes-navigatie, autoplay en swipe op touch */
if (!customElements.get('ts-hero')) {
    customElements.define('ts-hero', class extends HTMLElement {
        connectedCallback() {
            /* Kan meerdere keren afgaan als het element in de DOM verplaatst wordt */
            if (this.initialized) {
                this.restart();
                return;
            }
            this.initialized = true;
            this.slides = [...this.querySelectorAll('.ts-hero__slide')];
            this.dots = [...this.querySelectorAll('.ts-hero__dot')];
            this.index = 0;
            if (this.slides.length < 2) return;

            this.dots.forEach((dot) => {
                dot.addEventListener('click', () => {
                    this.go(Number(dot.dataset.index));
                    this.restart();
                });
            });

            let startX = null;
            this.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
            this.addEventListener('touchend', (e) => {
                if (startX === null) return;
                const dx = e.changedTouches[0].clientX - startX;
                startX = null;
                if (Math.abs(dx) < 40) return;
                this.go(this.index + (dx < 0 ? 1 : -1));
                this.restart();
            });

            this.delay = Number(this.dataset.autoplay) || 0;
            this.addEventListener('mouseenter', () => this.stop());
            this.addEventListener('mouseleave', () => this.restart());
            this.addEventListener('focusin', () => this.stop());

            /* Theme-editor: geselecteerde slide tonen */
            document.addEventListener('shopify:block:select', (e) => {
                const i = this.slides.indexOf(e.target);
                if (i > -1) { this.go(i); this.stop(); }
            });

            this.restart();
        }

        disconnectedCallback() {
            this.stop();
        }

        go(i) {
            const n = this.slides.length;
            this.index = (i + n) % n;
            this.slides.forEach((s, k) => {
                const active = k === this.index;
                s.classList.toggle('is-active', active);
                s.toggleAttribute('aria-hidden', !active);
                s.toggleAttribute('inert', !active);
            });
            this.dots.forEach((d, k) => {
                d.classList.toggle('is-active', k === this.index);
                d.setAttribute('aria-selected', String(k === this.index));
            });
        }

        stop() {
            clearInterval(this.timer);
        }

        restart() {
            this.stop();
            if (!this.delay || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
            this.timer = setInterval(() => this.go(this.index + 1), this.delay);
        }
    });
}
